import { useEffect, useState } from 'react';

// True below the md breakpoint (768px). Without matchMedia (e.g. jsdom) it is false, so the desktop table renders.
const MOBILE_QUERY = '(max-width: 767px)';

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => !!window.matchMedia?.(MOBILE_QUERY).matches);
    useEffect(() => {
        const mq = window.matchMedia?.(MOBILE_QUERY);
        if (!mq) return undefined;
        const onChange = (ev) => setIsMobile(ev.matches);
        mq.addEventListener?.('change', onChange);
        return () => mq.removeEventListener?.('change', onChange);
    }, []);
    return isMobile;
}
